import registerGridLayoutDirective from './GridLayoutDirective';
import StickyDirective from './StickyDirective';
import registerGridColDirective from './GridColDirective';

export default function registerGrid(angular) {
    angular.module('assessmentFrontendDirectives').directive('sticky', ['$interval', '$window', 'SheetLoadedService', function($interval, $window, SheetLoadedService) { return { link: function(scope, element, attrs) { new StickyDirective($interval, $window, SheetLoadedService).link(scope, element, attrs); } }; }]);
    registerGridColDirective(angular.module('assessmentFrontendDirectives'));
    registerGridLayoutDirective(angular.module('assessmentFrontendDirectives'));    
}